export default {
    welcome: 'Bienvenue sur notre site',
    loader : 'Chargement...',
    site_description : 'Cyberprotection tout-en-un',
    wait: 'Patienter...',
    footer: {
        copyright: 'Tous droits réservés par'
    },
    button: {
        btnTheme: 'Theme',
        lang: {
            EN: "EN",
            FR: "FR"
        },
        dark: 'Mode sombre',
        light: 'Mode clair',
        loggedin: 'Connexion',
        verify: {
            default: 'Vérifier',
            email: 'Vérifier mon adresse e-mail'
        },
        reset: 'Réinitialiser', 
        goback: 'Allez à la page d\'accueil',
        upgrade: 'Mise à niveau'
    },
    Actions: {
        not_defined: 'Aucune action définie pour {act}'
    },
    login: {
        connect: 'Connectez-vous!',
        passwd_forgot: 'Mot de passe oublié?',
        redirect: 'Redirection en cours, patienter...'
    },
    logout: {
        close: 'Déconnexion',
        title: 'Au plaisir de vous revoir !',
        content: 'Vous êtes maintenant déconnecté avec succès.'
    },
    form: {
        required: '{field} obligatoire'
    },
    email: {
        verify: {
            title: 'Activer votre compte',
            content: 'Entrez votre adresse e-mail pour recevoir un code de vérification et finaliser l’activation de votre compte.'
        }
    },
    otp: {
        title: 'Vérification du code OTP',
        content: 'Un code de vérification a été envoyé à l’adresse {email}.',
        empty: 'Vous n’avez pas reçu l’e-mail ?',
        resend: 'Renvoyer le code',
        progress: 'Envoi du code en cours…',
        wait: 'Veuillez patienter encore {minutes} minutes avant de demander un nouveau code.',
        retry_in: 'Nouveau code disponible dans {minutes}m {seconds}s'
    },
    page: {
        failed: {
            not_found: 'Page introuvable',
            content: 'La page recherchée est introuvable'
        }
    },
    access: {
        limited: 'Accès limité',
        upgrade: 'Passez à un forfait supérieur pour bénéficier d\'un accès illimité'
    }
}